import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { selectOption, tabCollection } from '../../commonClass/CommonInterfaceTypes';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import AccountDetails from './partial/AccountDetails';
import ETMAccountManagemnet from './partial/ETMAccountManagemnet';
import SupplierProfile from './partial/SupplierProfile';
import { SupplierData, SupplierDataModal, SupplierDropdownData } from './partial/SupplierUtils';



function SupplierManagement() {

    const dispatch = useDispatch();
    const location = useLocation();
    const locationsData = useSelector((store: any) => store.locationsdata.data);
    const [UserId, setUserId] = useState<number>(0);
    const [dropdownData, setDropdownData] = useState<SupplierDropdownData>({
        SupplierType: [],
        StateofIncorporation: [],
        DTravel: [],
        SupplierPaymentValue: [],
    })

    const defaultTab: tabCollection = {
        id: 1,
        idName: "pills-Profile-tab",
        name: "Supplier Profile",
        dataBsTarget: "#pills-Profile-Info",
        ariaControls: "pills-Profile-Info",
        ariaSelected: true,
    };

    const tabs: tabCollection[] = [
        {
            id: 1,
            idName: "pills-Profile-tab",
            name: "Supplier Profile",
            dataBsTarget: "#pills-Profile-Info",
            ariaControls: "pills-Profile-Info",
            ariaSelected: true,
        },
        {
            id: 2,
            idName: "pills-Account-Details-tab",
            name: "Account Details",
            dataBsTarget: "#pills-Account-Details-Info",
            ariaControls: "pills-Account-Details-Info",
            ariaSelected: true,
        },
        {
            id: 3,
            idName: "pills-Account-Management-tab",
            name: "ETM Account Management",
            dataBsTarget: "#pills-Account-Management-Info",
            ariaControls: "pills-Account-Management-Info",
            ariaSelected: true,
        }
    ];

    const [selectedTab, setSelectedTab] = useState(defaultTab);
    const [supplierData, setSupplierData] = useState<SupplierData>(new SupplierDataModal());

    const handleTabChange = (ele: tabCollection) => {
        setSelectedTab(ele);
    }

    const getsupplierbyid = async (supplierId: number) => {
        const supplierbyid = await postUsersData('/midoffice/v1/getsupplierbyid', { supplierId });
        if (supplierbyid?.status && supplierbyid?.data) {
            setSupplierData((prev) => ({ ...prev, SupplierProfile: supplierbyid?.data?.[0] }));
        }
    }
    const getsuppaccountbyid = async (supplierId: number) => {
        const suppaccountbyid = await postUsersData('/midoffice/v1/getsuppaccountbyid', { supplierId });
        if (suppaccountbyid?.status && suppaccountbyid?.data) {
            setSupplierData((prev) => ({ ...prev, AccountDetails: suppaccountbyid?.data?.[0] }));
        }
    }
    const getcontactbyid = async (supplierId: number) => {
        const contactbyid = await postUsersData('/midoffice/v1/getcontactbyid', { supplierId });
        if (contactbyid?.status && contactbyid?.data) {
            setSupplierData((prev) => ({ ...prev, AccountManagement: contactbyid?.data?.[0] }));
        }
    }

    const getsuppliertype = async () => {
        const suppliertype = await getAllData("/midoffice/v1/getsuppliertype");
        if (suppliertype?.status && suppliertype?.data) {
            setDropdownData((data) => ({
                ...data,
                SupplierType: suppliertype?.data
            }))
        }
    }
    const gethostate = async () => {
        const hostate = await getAllData("/midoffice/v1/gethostate");
        if (hostate?.status && hostate?.data) {
            const SOI: selectOption[] = [];
            hostate?.data?.forEach((obj: any) => {
                SOI?.push({ label: obj?.stateName, value: obj?.stateId })
            })
            setDropdownData((data) => ({
                ...data,
                StateofIncorporation: SOI
            }))
        }
    }
    const getpaymentpolicy = async () => {
        const paymentpolicy = await getAllData("/midoffice/v1/getpaymentpolicy");
        if (paymentpolicy?.status && paymentpolicy?.data) {
            const dTravel: selectOption[] = [];
            const paymentValue: selectOption[] = [];
            paymentpolicy?.data?.[0]?.dTravel?.forEach((obj: any) => {
                dTravel?.push({ label: obj?.DTravelValue, value: obj?.DTravelId })
            })
            paymentpolicy?.data?.[0]?.paymentValue?.forEach((obj: any) => {
                paymentValue?.push({ label: obj?.SPaymentValue, value: obj?.SPaymentId })
            })
            setDropdownData((data) => ({
                ...data,
                DTravel: dTravel,
                SupplierPaymentValue: paymentValue
            }))
        }
    }

    useEffect(() => {
        async function fetchData() {
            if (location?.state !== null) {
                dispatch(loaderActions.start())
                let statusoftoken = await verifytoken();
                if (statusoftoken) {
                    const user: any = GetLocalStorage();
                    setUserId(user?.userMasterID || 0);
                    Promise.allSettled([
                        getsuppliertype(),
                        gethostate(),
                        getpaymentpolicy(),
                        getsupplierbyid(location?.state?.Id),
                        getsuppaccountbyid(location?.state?.Id),
                        getcontactbyid(location?.state?.Id),
                    ])
                    dispatch(loaderActions.end())
                }
                else {
                    dispatch(loaderActions.end());
                    ClearLocalStorage();
                    dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                }
            }
        }
        fetchData();
    }, [location])


    return (
        <Fragment>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'>Supplier Management</h2>
            </div>
            <div className="m-2 heading_color">
                <h4>{selectedTab?.name} </h4>
            </div>
            <div className="m-2">
                <div className='container tab_section px-0'>
                    <ul className="nav nav-pills nav-justified mb-3 pt-3 col-12 " id="pills-tab" role="tablist">

                        {
                            tabs?.map((element) => {
                                return (
                                    <li
                                        key={element?.id}
                                        className="nav-item mt-1 mx-1"
                                        role="presentation"
                                        onClick={() => handleTabChange(element)}
                                    >
                                        <button className={`nav-link ${element?.id === selectedTab?.id && "active"}`}
                                            id={element?.idName}
                                            // data-bs-toggle="pill"
                                            // data-bs-target={element?.dataBsTarget}
                                            type="button" role="tab"
                                            aria-controls={element?.ariaControls}
                                            aria-selected={element?.ariaSelected}
                                        >
                                            <div className='fw-500'> {element?.name} </div>
                                        </button>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
                <div className="tab-content" id="pills-tabContent">
                    <div className={`tab-pane fade show ${selectedTab?.id === 1 && "active"}`} id="pills-Profile" role="tabpanel" aria-labelledby="pills-Profile-tab">
                        {
                            selectedTab?.id === 1 &&
                            <SupplierProfile
                                locationsData={locationsData}
                                dropdownData={dropdownData}
                                SupplierId={location?.state?.Id ?? 0}
                                disable={location?.state?.disabled ?? true}
                                editdisable={location?.state?.editdisabled ?? true}
                                cleardisable={location?.state?.cleardisabled ?? true}
                                type={location?.state?.type}
                                retrieveData={supplierData?.SupplierProfile}
                                UserId={UserId}
                                supplierList={location?.state?.supplierList || []}
                            />
                        }
                    </div>
                    <div className={`tab-pane fade show ${selectedTab?.id === 2 && "active"}`} id="pills-Account-Details" role="tabpanel" aria-labelledby="pills-Account-Details-tab">
                        {
                            selectedTab?.id === 2 &&
                            <AccountDetails
                                dropdownData={dropdownData}
                                SupplierId={location?.state?.Id ?? 0}
                                disable={location?.state?.disabled ?? true}
                                editdisable={location?.state?.editdisabled ?? true}
                                cleardisable={location?.state?.cleardisabled ?? true}
                                type={location?.state?.type}
                                retrieveData={supplierData?.AccountDetails}
                                UserId={UserId}
                                SupplierName={supplierData?.SupplierProfile?.supplierName}
                            />
                        }
                    </div>
                    <div className={`tab-pane fade show ${selectedTab?.id === 3 && "active"}`} id="pills-Account-Management" role="tabpanel" aria-labelledby="pills-Account-Management-tab">
                        {
                            selectedTab?.id === 3 &&
                            <ETMAccountManagemnet
                                SupplierId={location?.state?.Id ?? 0}
                                disable={location?.state?.disabled ?? true}
                                editdisable={location?.state?.editdisabled ?? true}
                                cleardisable={location?.state?.cleardisabled ?? true}
                                type={location?.state?.type}
                                retrieveData={supplierData?.AccountManagement}
                                UserId={UserId}
                                SupplierName={supplierData?.SupplierProfile?.supplierName}
                            />
                        }
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default SupplierManagement